"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVSProject = exports.isValidProjectV2 = exports.isValidProjectV3 = exports.isValidProject = exports.validateProjectSettings = void 0;
const tslib_1 = require("tslib");
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
const path = tslib_1.__importStar(require("path"));
const versionMetadata_1 = require("./versionMetadata");
function validateProjectSettings(projectSettings) {
    var _a;
    if (!projectSettings)
        return "empty projectSettings";
    if (!projectSettings.solutionSettings)
        return undefined;
    const solutionSettings = projectSettings.solutionSettings;
    let validateRes = validateStringArray(solutionSettings.azureResources);
    if (validateRes) {
        return `solutionSettings.azureResources validation failed: ${validateRes}`;
    }
    validateRes = validateStringArray(solutionSettings.capabilities);
    if (validateRes) {
        return `solutionSettings.capabilities validation failed: ${validateRes}`;
    }
    validateRes = validateStringArray(solutionSettings.activeResourcePlugins);
    if (validateRes) {
        return `solutionSettings.activeResourcePlugins validation failed: ${validateRes}`;
    }
    if ((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.solutionSettings) === null || _a === void 0 ? void 0 : _a.migrateFromV1) {
        return "The project created before v2.0.0 is only supported in the Teams Toolkit before v3.4.0.";
    }
    return undefined;
}
exports.validateProjectSettings = validateProjectSettings;
function validateStringArray(arr, enums) {
    if (!arr) {
        return "is undefined";
    }
    if (!Array.isArray(arr)) {
        return "is not array";
    }
    for (const element of arr) {
        if (typeof element !== "string") {
            return "array elements is not string type";
        }
        if (enums && !enums.includes(element)) {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            return `array elements is out of scope: ${enums}`;
        }
    }
    return undefined;
}
function isValidProject(workspacePath) {
    if (!workspacePath)
        return false;
    try {
        return isValidProjectV3(workspacePath) || isValidProjectV2(workspacePath);
    }
    catch (e) {
        return false;
    }
}
exports.isValidProject = isValidProject;
function isValidProjectV3(workspacePath) {
    const ymlFilePath = path.join(workspacePath, versionMetadata_1.MetadataV3.configFile);
    const localYmlPath = path.join(workspacePath, versionMetadata_1.MetadataV3.localConfigFile);
    if (fs_extra_1.default.pathExistsSync(ymlFilePath) || fs_extra_1.default.pathExistsSync(localYmlPath)) {
        return true;
    }
    return false;
}
exports.isValidProjectV3 = isValidProjectV3;
function isValidProjectV2(workspacePath) {
    const confFolderPath = path.resolve(workspacePath, `.${teamsfx_api_1.ConfigFolderName}`, "configs");
    const settingsFile = path.resolve(confFolderPath, "projectSettings.json");
    if (!fs_extra_1.default.existsSync(settingsFile)) {
        return false;
    }
    const projectSettings = fs_extra_1.default.readJsonSync(settingsFile);
    if (validateProjectSettings(projectSettings))
        return false;
    return true;
}
exports.isValidProjectV2 = isValidProjectV2;
function isVSProject(projectSettings) {
    return (projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.programmingLanguage) === "csharp";
}
exports.isVSProject = isVSProject;
//# sourceMappingURL=projectSettingsHelper.js.map